const ITEM_WINDOWS = 0, ITEM_DOOR_WINDOWS = 1, ITEM_BIG_WINDOW_DOORS = 2;
const MATERIAL_PVC = 0, MATERIAL_ALU = 1, MATERIAL_IDK = 2;
const STYLE_ACTUAL = 0, STYLE_CLASSIC = 1, STYLE_IDK = 2;
const OBJECTIVE_THERMAL = 0, OBJECTIVE_SOUND = 1, OBJECTIVE_SAFETY = 2, OBJECTIVE_LIGHT = 3;

let suppliersAjaxRoute = document.querySelector('#form-values').dataset.suppliersAjaxRoute;
const formNotValid = document.querySelector('#form-values').dataset.formValid;
const formPreviousJson = document.querySelector('#form-values').dataset.previousJson;
let selectedProductsTypes = [];

const Flow = {
  current_step: 0,
  rules: {
    stepTwo: false,
    stepFour: false,
  },
  steps: [
    {
      id: 0,
      container: document.querySelector('[data-target=\'introduction\']'),
      init_listener: function () {
        document.querySelector('#introduction button').addEventListener('click', function () {
          document.getElementById('introduction').classList.add('d-none');
          Flow.current_step = 1;

          dataLayer.push({
            'typeEnvironnement': 'www.storistes-de-france.com' === location.hostname ? 'Production' : 'Preproduction',
          });

          Flow.switch_to_step(1);
        });
      },
    },
    {
      id: 1,
      container: document.querySelector('[data-target=\'stepOne\']'),
      inputs: document.querySelectorAll('#module_conversion_search input'),
      button: document.querySelector('[data-from=\'stepOne\']'),
      navigation: document.querySelector('[data-trigger=\'stepOne\']'),
      init_listener: function () {
        this.button.addEventListener('click', () => {
          Flow.display_error(false);

          let values = [];
          let text_values = [];
          let choices = [ITEM_WINDOWS, ITEM_DOOR_WINDOWS, ITEM_BIG_WINDOW_DOORS];

          choices.forEach((id) => {
            // On ajoute tous les types de produits sélectionnés à l'étape 1 à values et text_values
            if (document.getElementById('module_conversion_search_' + id).checked) {
              values.push(id);
              let text = document.querySelector('[for=\'module_conversion_search_' + id + '\']').innerText;
              text_values.push('' + text);
            }
          });

          // On les ajoute à la liste des choix
          Flow.choices.search_items_id = values;
          Flow.choices_text.search_items_id = text_values;

          if (!values.length) {
            Flow.display_error(true);
            return false;
          }

          selectedProductsTypes = text_values.map(function (item) {
            const value = item.replace('Des ', '');

            return value.charAt(0).toUpperCase() + value.slice(1);
          });

          dataLayer.push({
            'event': 'CategorieProduit',
            'categorieProduit': selectedProductsTypes,
          });

          Flow.rules.stepTwo = true;
          Flow.rules.stepThree = true;
          let nextStep = 2;

          // Baies vitrées uniquement : pas d'étape 2
          if (
            JSON.stringify(values) === JSON.stringify([ITEM_BIG_WINDOW_DOORS])
          ) {
            nextStep = 3;
            Flow.rules.stepTwo = false;
          }

          // Portes-fenêtres uniquement : pas d'étape 3 (#38634)
          if (
            JSON.stringify(values) === JSON.stringify([ITEM_DOOR_WINDOWS])
          ) {
            Flow.rules.stepThree = false;
          }

          Flow.switch_to_step(nextStep);
        });
      },
    },
    {
      id: 2,
      container: document.querySelector('[data-target=\'stepTwo\']'),
      inputs: document.querySelectorAll('#module_conversion_materials label'),
      navigation: document.querySelector('[data-trigger=\'stepTwo\']'),
      previous: document.querySelector('#previous_stepTwo'),
      init_listener: function () {
        this.inputs.forEach((input) => {
          input.addEventListener('click', function () {
            let value = this.getAttribute('for');
            Flow.choices.material = parseInt(value.slice(-1));
            Flow.choices_text.material = this.innerText;

            dataLayer.push({
              'event': 'Materiaux',
              'categorieProduit': selectedProductsTypes,
            });

            // Pas d'étape 3 si le client n'est intéressé que par les portes fenêtres (#38634)
            if (!Flow.rules.stepThree) {
              Flow.switch_to_step(4);
            } else {
              Flow.switch_to_step(3);
            }
          });
        });
        this.previous.addEventListener('click', function () {
          Flow.switch_to_step(1);
        });
      },
    },
    {
      id: 3,
      current_child: 0,
      container: document.querySelector('[data-target=\'stepThree\']'),
      navigation: document.querySelector('[data-trigger=\'stepThree\']'),
      childs: [
        {
          search: ITEM_WINDOWS,
          material: MATERIAL_PVC,
          container: document.getElementById('windows_pvc'),
          button_next: document.querySelector('#windows_pvc a'),
          inputs: document.querySelectorAll('#windows_pvc input'),
          idk_button: document.querySelector('[for="module_conversion_opening_windows_pvc_4"]'),
          prefix: 'Fenetre PVC : ',
        },
        {
          search: ITEM_WINDOWS,
          material: MATERIAL_ALU,
          container: document.getElementById('windows_alu'),
          button_next: document.querySelector('#windows_alu a'),
          inputs: document.querySelectorAll('#windows_alu input'),
          idk_button: document.querySelector('[for="module_conversion_opening_windows_alu_5"]'),
          prefix: 'Fenetre ALU : ',
        },
        {
          search: ITEM_BIG_WINDOW_DOORS,
          material: null,
          container: document.getElementById('big_window_doors'),
          button_next: document.querySelector('#big_window_doors a'),
          inputs: document.querySelectorAll('#big_window_doors input'),
          idk_button: document.querySelector('[for="module_conversion_big_window_doors_2"]'),
          prefix: 'Baie vitrée : ',
        },
      ],
      init_listener: function () {
        dontKnowButton(this);
      },
      display_next_event: function () {
        // On a affiché les options pour les fenêtres et les baies vitrées, on peut passer à l'étape 4
        if (this.current_child >= 3) {
          dataLayer.push({
            'event': 'Ouverture',
            'categorieProduit': selectedProductsTypes,
          });

          if (JSON.stringify(Flow.choices.search_items_id) === JSON.stringify([ITEM_BIG_WINDOW_DOORS])) {
            Flow.switch_to_step(5);
            Flow.rules.stepFour = false;
          } else {
            Flow.switch_to_step(4);
            Flow.rules.stepFour = true;
          }
        }

        this.childs.forEach((item) => {
          item.container.classList.add('d-none');
        });

        let child = this.childs[this.current_child];

        if (!child) {
          return;
        }

        if (Flow.choices.search_items_id.includes(child.search) && (Flow.choices.material === child.material || child.material === null)) {
          child.container.classList.remove('d-none');
          let $this = this;
          let current = this.current_child;

          let old_element = child.button_next;
          let new_element = old_element.cloneNode(true);
          child.button_next = new_element;
          old_element.parentNode.replaceChild(new_element, old_element);

          child.button_next.addEventListener('click', function () {
            let values = [];
            let text_values = [];

            child.inputs.forEach((input) => {
              if (input.checked) {
                values.push(input.id);
                text_values.push(child.prefix + document.querySelector('[for=\'' + input.id + '\']').innerText);
              }
            });

            Flow.choices.customization.push(values);
            Flow.choices_text.customization.push(text_values);

            if (current >= 5) {
              dataLayer.push({
                'event': 'Ouverture',
                'categorieProduit': selectedProductsTypes,
              });

              Flow.switch_to_step(4);
            }

            Flow.steps[3].current_child++;
            $this.display_next_event();
          });
        } else {
          this.current_child++;
          this.display_next_event();
        }
      },
    },
    {
      id: 4,
      container: document.querySelector('[data-target=\'stepFour\']'),
      navigation: document.querySelector('[data-trigger=\'stepFour\']'),
      button: document.querySelector('[data-from=\'stepFour\']'),
      previous: document.getElementById('previous_stepFour'),
      childs: [
        {
          inputs: document.querySelectorAll('#styles input'),
          idk_button: document.querySelector('[for="module_conversion_styles_2"]'),
        },
      ],
      init_listener: function () {
        dontKnowButton(this);
        this.previous.onclick = null;
        this.previous.addEventListener('click', function () {
          Flow.steps[4].previous.click();

          if (!Flow.choices.material) {
            Flow.switch_to_step(2);
          } else {
            Flow.switch_to_step(3);
            Flow.steps[3].current_child = 0;
          }

        });

        this.button.addEventListener('click', () => {
          Flow.display_error(false);

          let values = [];
          let text_values = [];
          let styles = [STYLE_ACTUAL, STYLE_CLASSIC, STYLE_IDK];

          styles.forEach((id) => {
            if (document.getElementById('module_conversion_styles_' + id).checked) {
              values.push(id);
              text_values.push(document.querySelector('[for=\'module_conversion_styles_' + id + '\']').innerText);
            }
          });
          Flow.choices.styles = values;
          Flow.choices_text.styles = text_values;

          if (!values.length) {
            Flow.display_error(true);
            return false;
          }

          dataLayer.push({
            'event': 'Style',
            'categorieProduit': selectedProductsTypes,
          });

          Flow.switch_to_step(5);
        });

        document.querySelector('[for=\'module_conversion_styles_0\']').innerHTML += '<span>Les lignes épurées du style contemporain sauront vous séduire par leur modernité</span>';
        document.querySelector('[for=\'module_conversion_styles_1\']').innerHTML += '<span>Avec le style classique, jouez la carte du traditionnel grâce à ses lignes moulurées</span>';
      },
    },
    {
      id: 5,
      container: document.querySelector('[data-target=\'stepFive\']'),
      navigation: document.querySelector('[data-trigger=\'stepFive\']'),
      button: document.querySelector('[data-from=\'stepFive\']'),
      previous: document.getElementById('previous_stepFive'),
      init_listener: function () {
        this.previous.onclick = null;
        this.previous.addEventListener('click', function () {
          Flow.steps[5].previous.click();
          if (Flow.rules.stepFour) {
            Flow.switch_to_step(4);
          } else {
            Flow.switch_to_step(3);
            Flow.steps[3].current_child = 0;
          }
        });
        this.button.addEventListener('click', () => {
          Flow.display_error(false);

          let values = [];
          let text_values = [];
          let objectives = [OBJECTIVE_THERMAL, OBJECTIVE_SOUND, OBJECTIVE_SAFETY, OBJECTIVE_LIGHT];

          objectives.forEach((id) => {
            if (document.getElementById('module_conversion_goals_' + id).checked) {
              values.push(id);
              text_values.push(document.querySelector('[for=\'module_conversion_goals_' + id + '\']').innerText);
            }
          });
          Flow.choices.goals = values;
          Flow.choices_text.goals = text_values;

          if (!values.length) {
            Flow.display_error(true);
            return false;
          }

          dataLayer.push({
            'event': 'Amelioration',
            'categorieProduit': selectedProductsTypes,
          });

          Flow.display_contact_form();
        });
      },
    },
  ],
  choices: {
    search_items_id: [],
    material: null,
    styles: [],
    goals: [],
    customization: [],
  },
  choices_text: {
    search_items_id: [],
    material: null,
    styles: [],
    goals: [],
    customization: [],
  },
  init_listeners: function () {
    this.steps.forEach((step) => {
      step.init_listener();
    });

  },
  switch_to_step: function (step_number) {
    Flow.steps.forEach((item) => {
      if (item.container) {
        item.container.classList.remove('active');
        item.navigation.classList.remove('step--active');
        item.navigation.classList.remove('step--done');
        item.navigation.childNodes[1].innerText = item.navigation.getAttribute('data-value');
      }
    });

    let i = step_number - 1;

    while (i > 0) {
      let id = i;

      Flow.steps[i].navigation.classList.add('step--done');
      Flow.steps[i].navigation.childNodes[1].innerText = '';
      Flow.steps[i].navigation.onclick = null;
      Flow.steps[i].navigation.addEventListener('click', function (e) {
        e.preventDefault();

        /**
         * Si :
         * - essaye d'accéder à l'étape 2 alors que pas autorisé
         * - essaye d'accéder à l'étape 3 alors que pas autorisé
         * - essaye d'accéder à l'étape 4 alors que pas autorisé
         *
         * On ignore le clic sur la pastille
         */
        if (
          !(id === 2 && !Flow.rules.stepTwo) &&
          !(id === 3 && !Flow.rules.stepThree) &&
          !(id === 4 && !Flow.rules.stepFour)
        ) {
          if (id <= 3) {
            Flow.steps[3].current_child = 0;
          }

          Flow.current_step = id;
          Flow.switch_to_step(id);
        }
      });

      i--;
    }

    Flow.steps[step_number].container.classList.add('active');
    Flow.steps[step_number].navigation.classList.add('step--active');

    if (step_number === 1) {
      document.getElementById('main_container').classList.remove('d-none');
    }

    if (step_number === 3) {
      Flow.steps[3].display_next_event();
    }
    // goUpSmoothly();
  },
  display_error: function (display) {
    if (display) {
      document.getElementById('error').classList.remove('d-none');
    } else {
      document.getElementById('error').classList.add('d-none');
    }
  },
  display_contact_form: function () {
    document.getElementById('main_container').classList.add('d-none');
    document.getElementById('contact_container').classList.remove('d-none');

    if (!formNotValid) {
      document.getElementById('conversion_contact_choices').value = JSON.stringify(Flow.choices_text);
    }
  },
};

const dontKnowButton = (item) => {

  // boutons Je ne sais pas
  item.childs.forEach((child) => {
    child.idk_button.addEventListener('click', () => {
      item.childs.forEach((child_item) => {
        if (child_item.inputs) {
          child_item.inputs.forEach((input) => {
            if (input.id !== child.idk_button.getAttribute('for') && input.checked) {
              document.querySelector('[for="' + input.id + '"]').click();
            }
          });
        }
      });
    });
    child.inputs.forEach((input) => {
      if (input.id !== child.idk_button.getAttribute('for')) {
        input.addEventListener('click', () => {
          if (document.querySelector('#' + child.idk_button.getAttribute('for')).checked) {
            child.idk_button.click();
            document.querySelector('[for="' + input.id + '"]').click();
          }
        });
      }
    });
  });
};

const Contact = {
  init_listener: function () {
    let item = document.getElementById('conversion_contact_store');
    let timeout = null;
    item.addEventListener('keyup', function () {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        Contact.updateList(item.value);
      }, 500);
    });

    document.getElementById('conversion-contact-form').addEventListener('submit', function () {
      dataLayer.push({
        'event': 'ValidationForm',
        'categorieProduit': selectedProductsTypes,
      });
    });
  },
  updateList: function (value) {

    let completeAddress = `France ${value}`;
    let form_input = document.getElementById('conversion_contact_store_json');
    let container = document.getElementById('result_container');
    let result = document.getElementById('result_text');

    container.innerHTML = null;
    result.innerHTML = null;

    let request = new Request(
      suppliersAjaxRoute, {
        method: 'POST',
        body: completeAddress,
      });

    container.innerHTML = 'Chargement...';
    fetch(request)
      .then(response => response.json())
      .then(data => {
        container.innerHTML = null;
        if (0 < data.length) {
          data.forEach((item) => {
            let node = document.createElement('button');
            node.classList.add('btn', 'btn-outline-pinewood', 'btn--medium', 'w-100');
            node.innerHTML = item.title + ', ' + item.address;
            node.addEventListener('click', function () {
              form_input.value = item.id;
              container.innerHTML = null;
              result.innerHTML = '<p class="font-weight-bold">Votre magasin : ' + item.title + ', ' + item.address + '</p>';
            });
            container.append(node);
          });
        } else if (data.error) {
          container.innerHTML = '<span class="text-danger ff-wotfard-l fs-14">Adresse non valide.</span>';
        } else {
          container.innerHTML = 'Aucun magasin.';
        }
      });
  },
};

// Gerer les erreurs ici

// let lastForm = document.querySelector('[name="conversion_contact"]');
// let inputs = lastForm.querySelectorAll('input');

// document.getElementById('conversion_contact_submit').addEventListener('click', function (e) {
//   e.preventDefault();
//   document.querySelectorAll('.has-error').forEach(function (item) {
//     item.classList.remove('has-error');
//   })

//   inputs.forEach(function (input) {

//     if (input.getAttribute('type') === 'text') {
//       if (input.value === "") {
//         input.classList.add('has-error')
//       }
//     }
//   })
// })

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

Flow.init_listeners();
Contact.init_listener();

if (formNotValid) {
  document.getElementById('introduction').classList.add('d-none');
  Flow.display_contact_form();
}

// Decommenter ca pour afficher le formulaire directement
// document.getElementById('introduction').classList.add('d-none');
// Flow.display_contact_form();
